export default {"src":"/_next/static/media/tourismlogo1.93a8cdc5.svg","height":42,"width":160,"blurWidth":0,"blurHeight":0};